<div class="bg_calculator pb-7">
  <app-headercontent></app-headercontent>
  <div class="container">
    <div class="cont__select">
      <div class="row mb-2">
        <div class="col-md-12">
          <strong>Selecciona tu CUPRA por:</strong>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <ngb-accordion [closeOthers]="true" id="select__cupra">
            <ngb-panel title="Matrícula" id="search__plate">
              <ng-template ngbPanelContent>
                <div class="row">
                  <div class="col-md-4">
                    <input type="text" class="form-control" [(ngModel)]="matricula" #licenseplate="ngModel" placeholder="1111AAA" pattern="[0-9]{4}[a-zA-z]{3}" />
                    <div *ngIf="licenseplate.errors?.pattern">
                      La matrícula introducida debe seguir el siguiente formato (1111AAA).
                    </div>
                  </div>
                  <div class="col-md-8" *ngIf="!licenseplate.errors?.pattern">
                    <button type="button" class="btn btn-primary" (click)="SelectMatricula()">Siguiente</button>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Número de bastidor" id="search__vin">
              <ng-template ngbPanelContent>
                <div class="row mb-1">
                  <div class="col-md-6">
                    <input type="text" class="form-control" [(ngModel)]="bastidor" placeholder="VSSXXXXXXXXXXXXXX" />
                  </div>
                  <div class="col-md-6">
                    <button type="button" class="btn btn-primary" (click)="SelectBastidor()">Siguiente</button>
                  </div>
                </div>
                <a class="more-info-modal" (click)="openVerticallyCentered(content)">Número de bastidor</a>
              </ng-template>
            </ngb-panel>
            <ngb-panel title="Modelo" (shown)="setCarouselPosition()">
              <ng-template ngbPanelContent>
                <ngb-carousel *ngIf="cupramodels.length > 0" [interval]="0" [wrap]="true" (slid)="onSlid($event)" (slide)="onSlide($event)" id="carrusel" [showNavigationIndicators]="showNavigationIndicators" class="model__select">
                  <ng-container *ngFor="let model of cupramodels; let i = index;">
                    <ng-template ngbSlide [id]="'slide-' + i">
                      <div class="text-center cupra-model-container">
                        <h3>{{model.Model}}</h3>
                        <img [src]="pathServer + model.Image" alt="{{model.Model}}">
                      </div>
                      <div *ngIf="selectedVersion" class="selected__version">
                        <div class="data__selected">
                          <div class="motortype">{{selectedVersion.MotorType}}</div>
                          <div class="version">{{selectedVersion.Version}}</div>
                        </div>
                      </div>
                      <div class="select__engine">
                        <ngb-accordion [activeIds]="activeIds">
                          <ngb-panel>
                            <ng-template ngbPanelTitle>
                              <h5>Selecciona motorización</h5>
                            </ng-template>
                            <ng-template ngbPanelContent>
                              <ng-container *ngFor="let motortype of motortypeversions">
                                <span class="list-group-item list-group-item-primary">{{motortype.MotorType}}</span>
                                <div class="list-group versions">
                                  <ng-container *ngFor="let version of motortype.ModelVersions">
                                    <a [ngClass]="{'list-group-item-active': selectedVersion && selectedVersion.Version == version.Version}" (click)="SelectVersion(version);" class="list-group-item">{{version.Version}}</a>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-template>
                          </ngb-panel>
                        </ngb-accordion>
                      </div>
                      <div *ngIf="showValidationMotorVersionError == true && this.selectedVersion == null" class="invalid-feedback text-center d-block">Debes indicar la motorización</div>
                    </ng-template>
                  </ng-container>
                </ngb-carousel>
                <div class="row mt-4">
                  <div class="col-md-12 text-center">
                    <button type="button" class="btn btn-primary btn-engine" (click)="SelectModelo()">Siguiente</button>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
      <div id="oldBudgetSearchForm">
        <div class="row mt-4">
          <div class="col-md-12">
            <label for="oldBudget" class="italic_label mb-3">Recuperar presupuesto*</label>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input type="text" class="form-control" id="oldBudget" [(ngModel)]="oldBudget" />
              <div *ngIf="showValidationBudgetError == true" class="invalid-feedback d-block">Debes introducir un código de presupuesto</div>
            </div>
            <div class="col-md-4">
              <button type="button" class="btn btn-primary" (click)="goToOldBudget()" (change)="this.showValidationBudgetError=false">Buscar</button>
            </div>
          </div>
        </div>
        <div class="row mb-7">
          <div class="col-md-12">
            <p class="form-text text-muted">*Introduce el código asociado a tu presupuesto, el cual encontrarás en la documentación generada al descargar en PDF o enviar por email dicho presupuesto.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">UBICACIÓN DEL NÚMERO DE BASTIDOR</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <img src="../../../../assets/images/vin-number.jpg" alt="Número de bastidor" class="img-fluid mb-3">
    <p><strong>También aparece en la ficha técnica de tu CUPRA.</strong></p>
    <p>El <strong>número de bastidor o VIN</strong> (Vehicle Identification Number) de un coche, presente a partir de 1981, es una <strong>combinación de 17 dígitos alfanuméricos</strong> única que identifica a todos los vehículos de forma exacta sin
      posibilidad de error.</p>
  </div>
  <!-- <div class="modal-footer">
            <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Close</button>
        </div> -->
</ng-template>
<div [class.show]="showCustomAlert" (click)="hideAlert()" id="customAlertContainer">
  <button type="button" class="btn-close btn-close-white" aria-label="Close"></button>
  <div class="alertContent">
    <div class="alertIcon"></div>
    <div>
      <h4 *ngIf="this.alertContent.title != ''" class="alertTitle">{{this.alertContent.title}}</h4>
      <p *ngIf="this.alertContent.text != ''" class="alertText">{{this.alertContent.text}}</p>
    </div>
    <!-- <button type="button" class="btn btn-sm btn-outline-light">Cerrar</button> -->
  </div>
</div>